module.exports = __webpack_public_path__ + "img/imgYLSYB(14).d4bb21ff.png";